import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./styles/App.css";
import { useState } from "react";
import Toast from "./components/common/Toast";
import Header from "./components/Header";
import Footer from "./components/Footer";

import RegisterPage from "./pages/RegisterPage";
import ArtPage from "./pages/ArtPage";

import artRoutes from "./routes/artRoutes";
import codeRoutes from "./routes/codeRoutes";

function App() {
  const [toast, setToast] = useState(null);

  const showToast = (message, type = "success") => {
    setToast({ id: Date.now(), message, type });
  };

  const handleCloseToast = () => {
    setToast(null);
  };

  return (
    <Router>
      <div className="app">
        <Header />
        {toast && (
          <Toast
            key={toast.id}
            message={toast.message}
            type={toast.type}
            onClose={handleCloseToast}
          />
        )}
        <main>
          <Routes>
            <Route
              path="/register"
              element={<RegisterPage showToast={showToast} />}
            />

            {artRoutes.map(({ path, element }) => (
              <Route
                key={path}
                path={path}
                element={element}
              />
            ))}

            {codeRoutes.map(({ path, element }) => (
              <Route
                key={path}
                path={path}
                element={element}
              />
            ))}

            {/* Route mặc định hoặc 404 */}
            <Route
              path="*"
              element={<ArtPage />}
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
